module.exports = __webpack_public_path__ + "static/media/line-size-2.950fac3c.svg";